<ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="link$ | async as promoLink">
    <ng-template
      [cxComponentWrapper]="{ flexType: promoLink.typeCode, typeCode: promoLink.typeCode, uid: promoLink?.uid }"
    >
    </ng-template>
  </ng-container>
</ng-container>
